import React, { useEffect } from "react";
import Footer from "../../shared/Footer/Footer";
import Navbar from "../../shared/Navbar/Navbar";
import amiyaChakmaImage from "../../../images/Photos/amiya-sagor-chakma.jpg";
import MonirulHasan from "../../../images/Photos/Monirul-hasan.jpg";
import AbdulBari from "../../../images/Photos/Dr. Muhammad Abdul Bari.jpg";
import koalKhisa from "../../../images/Photos/koal-khisa.jpg";
import BiplobBanerjee from "../../../images/Photos/biplob-banerjee.jpg";
import BhubonChakma from "../../../images/Photos/Bhubon-bijoy-chakma.jpg";
import YeasinMonju from "../../../images/Photos/Yeasin Monju.jpg";
import SaikatBarua from "../../../images/Photos/Saikat-barua.jpg";
import ArnobChakma from "../../../images/Photos/Arnob-chakma.jpg";
import UdvasanChakma from "../../../images/Photos/UDAVASAN Chakma.jpg";
import SharanikaChakma from "../../../images/Photos/Sharanika Chakma.jpg";
import ArijitKumarRoy from "../../../images/Photos/Arijit Kumar Roy.jpg";
import NoorEJannat from "../../../images/Photos/Noor-e-jannat.jpg";
import "../../../style/about/smt.css";
import Zoom from "react-reveal/Zoom";
import TranslateButton from "../../TranslateButton/TranslateButton";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

const SMT = () => {
  useEffect(() => {
    document.title = `AshroyAngon | Senior Management System`;
  }, []);

  const shareUrl = "https://ashroyangon.org/about/senior-management-team";

  return (
    <>
      <Navbar />
      <TranslateButton />

      <div className="senior_management_team_section">
        {/* Header Background Part Start */}
        <div className="header_background">
          <div className="container wrapper">
            <h2>Senior Management Team</h2>
            <div className="social_share_button">
              <FacebookShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share facebook"}
                hashtag={"#facebook"}
              >
                <FacebookIcon size={35} round={true} />
              </FacebookShareButton>
              <TwitterShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share twitter"}
                hashtag={"#twitter"}
              >
                <TwitterIcon size={35} round={true} />
              </TwitterShareButton>
              <LinkedinShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share linkedin"}
                hashtag={"#linkedin"}
              >
                <LinkedinIcon size={35} round={true} />
              </LinkedinShareButton>
            </div>
          </div>
        </div>
        {/* Header Background Part End */}

        <div className="container">
          <div className="title_header">
            <p>
              The Senior Management Team (SMT) provides day to day leadership
              for the organization such as determining strategic, programmatic
              and operational issues and delivery against action plan and budget
              of Ashroy Angon Society's projects/programmes as implementing
              authority of EC. SMT is accountable to EC for outcomes and
              exercise of authority.
            </p>
          </div>

          <div className="Ed_image">
            <Zoom duration={3000}>
              <div className="single_wrapper">
                <img src={amiyaChakmaImage} loading="lazy" alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Amiya Sagar Chakma, MBA</h4>
                  <p>Executive Director (ED)</p>
                </div>
              </div>
            </Zoom>
          </div>

          <div className="content_wrapper">
            <Zoom duration={3000}>
              <div className="single_wrapper">
                <img src={ArijitKumarRoy} loading="lazy" alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Arijit Kumar Roy, MA(UK), MEd(DU)</h4>
                  <p>
                    Deputy Executive Director (DED)
                  </p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_wrapper">
                <img src={koalKhisa} loading="lazy" alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Shubra Pradip Khisa, MA</h4>
                  <p>Project Manager</p>
                  <p>Manager, MEAL & Reporting and HRAPL</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_wrapper">
                <img src={BhubonChakma} loading="lazy" alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Bhuban Bijoy Chakma, MBA</h4>
                  <p>Manager, Finance & Accounts</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_wrapper">
                <img src={AbdulBari} loading="lazy" alt="" />
                <div className="title_wrapper">
                  <h4>Dr. Muhammad Abdul Bari, PhD</h4>
                  <p>
                    Funding & Investment Consultant
                  </p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_wrapper">
                <img src={ArnobChakma} loading="lazy" alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Arnob Chakma, MA</h4>
                  <p>Manager, Document and Organization Development (DOD) </p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_wrapper">
                <img src={YeasinMonju} loading="lazy" alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Yeasin Monju, MBA</h4>
                  <p>Manager, Communication & Fund Raising (CFR) and Trainer</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_wrapper">
                <img src={MonirulHasan} loading="lazy" alt="" />
                <div className="title_wrapper">
                  <h4>Md. Monirul Hasan, MBA, PGDPM</h4>
                  <p>Technical Advisor</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_wrapper">
                <img src={SaikatBarua} loading="lazy" alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Saikat Barua, BSS</h4>
                  <p>Officer (HRAPL)</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_wrapper">
                <img src={SharanikaChakma} loading="lazy" alt="" />
                <div className="title_wrapper">
                  <h4>Ms. Sharanika Chakma, MA</h4>
                  <p>Officer, Documentation & Organization Development</p>
                  <p>and Safeguarding Focal</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_wrapper">
                <img src={NoorEJannat} loading="lazy" alt="" />
                <div className="title_wrapper">
                  <h4>Ms. Noor-E-Jannat, MBA</h4>
                  <p>Assistant Officer, HRAPL & Assistant Accounts Officer</p>
                </div>
              </div>
            </Zoom>

            {/* <Zoom duration={3000}>
              <div className="single_wrapper">
                <img src={ResleeChakma} loading="lazy" alt="" />
                <div className="title_wrapper">
                  <h4>Ms. Reslee Chakma, MSc</h4>
                  <p>Upazila Program Manager</p>
                  <p>Rangamati Sadar Upazila</p>
                  <button className="button">
                    <Link
                      className="link_profile"
                      to="/ms-reslee-chakma-cv"
                      target={"_blank"}
                    >
                      Click Profile
                    </Link>
                  </button>
                </div>
              </div>
            </Zoom> */}

            {/* <Zoom duration={3000}>
              <div className="single_wrapper">
                <img src={PravatTanchangya} loading="lazy" alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Pravat Tanchangya, MSS</h4>
                  <p>Upazila Program Manager</p>
                  <p>Kaptai Upazila</p>
                  <button className="button">
                    <Link
                      className="link_profile"
                      to="/mr-pravat-tanchangya-cv"
                      target={"_blank"}
                    >
                      Click Profile
                    </Link>
                  </button>
                </div>
              </div>
            </Zoom> */}

            {/* <Zoom duration={3000}>
              <div className="single_wrapper">
                <img src={RupeshChakma} loading="lazy" alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Rupesh Chakma, MA</h4>
                  <p>Upazila Program Manager</p>
                  <p>Belaichari Upazila</p>
                  <button className="button">
                    <Link
                      className="link_profile"
                      to="/mr-rupesh-chakma-cv"
                      target={"_blank"}
                    >
                      Click Profile
                    </Link>
                  </button>
                </div>
              </div>
            </Zoom> */}

            {/* <Zoom duration={3000}>
              <div className="single_wrapper">
                <img src={UchimongMarma} loading="lazy" alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Uchi Mong Marma, MA</h4>
                  <p>Upazila Program Manager</p>
                  <p>Kawkhali Upazila</p>
                  <button className="button">
                    <Link
                      className="link_profile"
                      to="/mr-uchi-mong-marma-cv"
                      target={"_blank"}
                    >
                      Click Profile
                    </Link>
                  </button>
                </div>
              </div>
            </Zoom> */}

            {/* <Zoom duration={3000}>
              <div className="single_wrapper">
                <img src={bikochakmaImage} loading="lazy" alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Biko Chakma, MA</h4>
                  <p>Upazila Program Manager</p>
                  <p>Jurachari Upazila</p>
                  <button className="button">
                    <Link
                      className="link_profile"
                      to="/mr-biko-chakma-cv"
                      target={"_blank"}
                    >
                      Click Profile
                    </Link>
                  </button>
                </div>
              </div>
            </Zoom> */}

            {/* <Zoom duration={3000}>
              <div className="single_wrapper">
                <img src={MuiThuiAungMarma} loading="lazy" alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Mui Thui Aung Marma, MA</h4>
                  <p>Upazila Program Manager</p>
                  <p>Rajasthali Upazila</p>
                  <button className="button">
                    <Link
                      className="link_profile"
                      to="/mr-mui-thui-aung-marma-cv"
                      target={"_blank"}
                    >
                      Click Profile
                    </Link>
                  </button>
                </div>
              </div>
            </Zoom> */}


          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SMT;
